
  var _styles = {
  "count-down-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "count-down-time": {
    "color": "rgb(255,45,25)",
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem"
  },
  "count-down-suffix": {
    "color": "rgb(17,17,17)",
    "fontWeight": "400",
    "marginLeft": "0.05333rem",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem"
  }
};



  module.exports = _styles;
  